import React from "react";

const BusinessMeaning = () => {
  return (
    <section className="section px-6 py-24 max-w-7xl mx-auto">
      <div className="grid lg:grid-cols-2 gap-16 items-center">
        {/* Left text */}
        <div className="space-y-6">
          <div className="badge">
            <span className="badge-dot" />
            For Businesses
          </div>
          <h2
            className="font-syne font-bold leading-tight"
            style={{ fontSize: "clamp(32px, 4vw, 54px)", color: "#e8eaf0" }}
          >
            What Does This Mean <span className="grad-text">for Businesses?</span>
          </h2>
          <p
            className="text-base leading-relaxed"
            style={{ color: "var(--c-muted)", fontFamily: "'DM Sans', sans-serif" }}
          >
            As a business entity, you can enable your users to effortlessly send crypto across different blockchain networks supported by Cahex — or even make crypto transfers to a digital bank account.
          </p>
          <p
            className="text-base leading-relaxed"
            style={{ color: "var(--c-muted)", fontFamily: "'DM Sans', sans-serif" }}
          >
            TRON is one of the blockchain networks integrated by Cahex Network. By helping TRON access more liquidity via Cahex Network, we enable TRON dApps and users to make cross-chain money transfers across the TRON ecosystem.
          </p>

          <div className="grad-divider" />

          <div className="flex gap-8 pt-2">
            {[["Cross-Chain", "Transfers"], ["AML", "Compliant"], ["No Wrapping", "Tokens"]].map(([a, b]) => (
              <div key={a}>
                <div className="font-syne font-bold text-sm grad-text">{a}</div>
                <div className="text-xs mt-0.5" style={{ color: "var(--c-muted)" }}>{b}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Right visual */}
        <div className="flex justify-center">
          <div className="relative w-80 h-80">
            {/* Outer ring */}
            <div
              className="spin-slow absolute inset-0 rounded-full"
              style={{ border: "1px solid rgba(82,198,168,0.15)" }}
            />
            {/* Inner ring */}
            <div
              className="spin-slow absolute"
              style={{
                inset: "30px", borderRadius: "50%",
                border: "1px dashed rgba(79,142,247,0.12)",
                animationDirection: "reverse", animationDuration: "12s",
              }}
            />
            {/* Center hexagon */}
            <div className="absolute inset-0 flex items-center justify-center">
              <div
                className="glow-box rounded-2xl flex flex-col items-center justify-center gap-3"
                style={{
                  width: "160px", height: "160px",
                  background: "rgba(13,17,32,0.95)",
                }}
              >
                <div
                  className="font-syne font-black text-5xl grad-text"
                  style={{ lineHeight: 1 }}
                >
                  C
                </div>
                <div className="text-xs font-syne" style={{ color: "var(--c-muted)" }}>CAHEX</div>
              </div>
            </div>
            {/* Labels around */}
            {[
              { label: "TRON", angle: 0 },
              { label: "ETH", angle: 120 },
              { label: "BTC", angle: 240 },
            ].map(({ label, angle }) => {
              const rad = (angle * Math.PI) / 180;
              const r = 140;
              const x = 160 + r * Math.cos(rad) - 20;
              const y = 160 + r * Math.sin(rad) - 12;
              return (
                <div
                  key={label}
                  className="absolute font-syne font-bold text-xs px-3 py-1 rounded-full"
                  style={{
                    left: x, top: y,
                    background: "rgba(82,198,168,0.1)",
                    border: "1px solid rgba(82,198,168,0.3)",
                    color: "#52c6a8",
                  }}
                >
                  {label}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BusinessMeaning;
